import { consumer } from "./index"

class ChatRoomChannel {
  constructor(roomId, callbacks = {}) {
    this.roomId = roomId
    this.callbacks = callbacks
    this.subscription = null
    this.typingTimeout = null
  }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "ChatRoomChannel", room_id: this.roomId },
      {
        connected: () => {
          console.log(`Connected to chat room ${this.roomId}`)
          this.callbacks.onConnected?.()
        },

        disconnected: () => {
          console.log(`Disconnected from chat room ${this.roomId}`)
          this.callbacks.onDisconnected?.()
        },

        received: (data) => {
          this.handleReceived(data)
        }
      }
    )

    return this
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }

  sendMessage(content, messageType = "text", replyToId = null) {
    if (!this.subscription) return

    this.subscription.perform("receive", {
      content: content,
      message_type: messageType,
      reply_to_id: replyToId
    })
  }

  typing() {
    if (!this.subscription) return

    this.subscription.perform("typing")

    // Auto stop typing after 3 seconds
    clearTimeout(this.typingTimeout)
    this.typingTimeout = setTimeout(() => {
      this.stopTyping()
    }, 3000)
  }

  stopTyping() {
    if (!this.subscription) return

    clearTimeout(this.typingTimeout)
    this.subscription.perform("stop_typing")
  }

  markRead() {
    if (!this.subscription) return

    this.subscription.perform("mark_read")
  }

  handleReceived(data) {
    switch (data.type) {
      case "marketplace_status":
        this.callbacks.onMarketplaceStatus?.(data.product)
        break
      case "message_error":
        this.callbacks.onMessageError?.(data.error, data.content)
        break
      case "message":
        this.callbacks.onMessage?.(data.message)
        break
      case "typing":
        this.callbacks.onTyping?.(data.mb_id, data.nickname)
        break
      case "stop_typing":
        this.callbacks.onStopTyping?.(data.mb_id)
        break
      case "read_update":
        this.callbacks.onReadUpdate?.(data.participant_read_times, data.online_members)
        break
      case "presence":
        this.callbacks.onPresence?.(data.mb_id, data.status, data.online_members)
        break
      case "reaction_update":
        this.callbacks.onReactionUpdate?.(data.message_id, data.reactions)
        break
      default:
        console.log("Unknown message type:", data.type)
    }
  }
}

export default ChatRoomChannel
